import { ReactElement, memo } from 'react';
import { Chip, SxProps, Theme } from '@mui/material';

interface OrderRevisitChipProps {
  label?: string;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

const OrderRevisitChip = ({
  label = 'REVISITA',
  size = 'medium',
  sx = {},
}: OrderRevisitChipProps): ReactElement => (
  <Chip
    label={label}
    size={size}
    variant="filled"
    sx={{
      ...sx,
      fontWeight: 'bold',
      backgroundColor: '#FDF3E2',
      color: '#B4690E',
      minWidth: 100,
    }}
  />
);

export default memo(OrderRevisitChip);
